import ApiClient from './ApiClient';

export default class DropdownApi {
  constructor(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;
  }

  getDropdowns() {
    return this.apiClient.get({ path: '/api/dropdowns' });
  }

  addDropdown(body) {
    return this.apiClient.post({ path: '/api/dropdowns', body });
  }

  listOptions(dropdownId) {
    // verify the required parameter 'dropdownId' is set
    if (dropdownId === undefined || dropdownId === null) {
      throw new Error("Missing the required parameter 'dropdownId' when calling listOptions");
    }
    return this.apiClient.get({ path: `/api/dropdowns/${dropdownId}/options` });
  }

  addOption(dropdownId, body) {
    // verify the required parameter 'dropdownId' is set
    if (dropdownId === undefined || dropdownId === null) {
      throw new Error("Missing the required parameter 'dropdownId' when calling addOption");
    }
    return this.apiClient.post({ path: `/api/dropdowns/${dropdownId}/options`, body });
  }

  deleteOption(dropdownId, optionId) {
    // verify the required parameter 'dropdownId' is set
    if (dropdownId === undefined || dropdownId === null) {
      throw new Error("Missing the required parameter 'dropdownId' when calling deleteOption");
    }
    // verify the required parameter 'optionId' is set
    if (optionId === undefined || optionId === null) {
      throw new Error("Missing the required parameter 'optionId' when calling deleteOption");
    }
    return this.apiClient.del({ path: `/api/dropdowns/${dropdownId}/options/${optionId}` });
  }

  updateOption(dropdownId, optionId, body) {
    // verify the required parameter 'dropdownId' is set
    if (dropdownId === undefined || dropdownId === null) {
      throw new Error("Missing the required parameter 'dropdownId' when calling updateOption");
    }
    // verify the required parameter 'optionId' is set
    if (optionId === undefined || optionId === null) {
      throw new Error("Missing the required parameter 'optionId' when calling updateOption");
    }
    return this.apiClient.put({ path: `/api/dropdowns/${dropdownId}/options/${optionId}`, body });
  }

  getOptionValues(dropdownId, languageId, opts) {
    // verify the required parameter 'dropdownId' is set
    if (dropdownId === undefined || dropdownId === null) {
      throw new Error("Missing the required parameter 'dropdownId' when calling getOptionValues");
    }
    // verify the required parameter 'languageId' is set
    if (languageId === undefined || languageId === null) {
      throw new Error("Missing the required parameter 'languageId' when calling getOptionValues");
    }
    return this.apiClient.get({ path: `/api/dropdowns/${dropdownId}/${languageId}/values`, params: (opts || {}) });
  }

  getDropdown(id) {
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling getDropdown");
    }
    return this.apiClient.get({ path: `/api/dropdowns/${id}` });
  }

  deleteDropdown(id) {
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling deleteDropdown");
    }
    return this.apiClient.del({ path: `/api/dropdowns/${id}` });
  }

  updateDropdown(id, body) {
    // verify the required parameter 'id' is set
    if (id === undefined || id === null) {
      throw new Error("Missing the required parameter 'id' when calling updateDropdown");
    }
    return this.apiClient.put({ path: `/api/dropdowns/${id}`, body });
  }
}
